import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import {
  isPurchaseActionTreeRight,
  isSubscribeActionTreeRight,
  isAcquisitionActionTreeLeft,
  isAcquisitionActionTreeRight
} from '../utils/getAcquisitionActionChildren'
import { flattenArray, truthy } from '../utils/utils'

// Until now, there is no use case for tvodWinners to be a PurchaseActionTreeLeft. This is not supported in Nody2, so in
// such a case we do not print anything and we log an error in WPS (AVWebDetailPage-3100).
export const getTvodWinnersMetadata = (
    action?: WpsRuntime.atv.wps.AcquisitionActionTreeModelProps
): WpsRuntime.atv.wps.DVString[] =>
    (isPurchaseActionTreeRight(action) && action.metadata && action.metadata.messages) || []

// Until now, there is no use case for tvodWinners to be a PurchaseActionTreeLeft. This is not supported in Nody2, so in
// such a case we do not print anything and we log an error in WPS (AVWebDetailPage-3100).
export const getTvodWinnersChildren = (
  action?: WpsRuntime.atv.wps.PurchaseActionTreeModelProps
): WpsRuntime.atv.wps.PurchaseActionProps[] =>
  (isPurchaseActionTreeRight(action) && action.children) || []

export const getSvodWinnersChildren = (
  action?: WpsRuntime.atv.wps.SubscribeActionTreeModelProps
): WpsRuntime.atv.wps.SubscribeAction[] =>
  (isSubscribeActionTreeRight(action) && action.children) || []

export const getMoreWaysToWatchChildren = (
  action?: WpsRuntime.atv.wps.AcquisitionActionTreeModelProps
): WpsRuntime.atv.wps.AcquisitionActionProps[] => {
  const leftAction = (isAcquisitionActionTreeLeft(action) && action.children) || []
  return flattenArray(leftAction.map((rightAction: WpsRuntime.atv.wps.AcquisitionActionTreeModelProps) =>
    (isAcquisitionActionTreeRight(rightAction) && rightAction.children) || []
  ))
}

export const getMoreWaysToWatchChildrenGroups = (
  action?: WpsRuntime.atv.wps.AcquisitionActionTreeModelProps
) => {
  const leftAction = (isAcquisitionActionTreeLeft(action) && action.children) || []
  return leftAction.map((rightAction: WpsRuntime.atv.wps.AcquisitionActionTreeModelProps) =>
    isAcquisitionActionTreeRight(rightAction) && rightAction
  ).filter(truthy)
}